/**
 * 用户组列表功能
 * @Author:wuTao
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateCofig, templateConfig} from './config'

import {framework_tool, utils_tool} from "@/tool";

let {WizContainer, WizReduxTemplate} = framework_tool;
let {checkStrLength} = utils_tool;
class GroupList extends WizContainer {

  componentName = 'GroupList';

  constructor(props) {
    super(props);
    this.state = {}
  }

  /**
   * 页面动作操作后进行提示
   * @param nextProps
   * @param nextState
   * @param key
   * @returns {boolean}
   * @private
   */
  _handleUser(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        add: this._handleUser,
        update: this._handleUser,
        delete: this._handleUser,
        updateGroupState:this._handleUser,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(GroupList);
